export default __webpack_public_path__ + "static/media/florence_profile.ca9afabf.jpg";